<template>
  <div>
    <div v-if="show" ref="container" class="banner-fixed" :style="{ top: `${top}px` }">
      <slot></slot>
    </div>
    <div v-if="show" :style="{ height: `${height}px` }"></div>
  </div>
</template>

<script>
  export default {
    name: "BannerFixedSlot",
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      top: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        height: 0,
      };
    },
    mounted() {
      window.addEventListener("resize", this.updateHeight);
      this.refreshHeightOnNextTick();
    },
    updated() {
      this.refreshHeightOnNextTick();
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.updateHeight);
    },
    methods: {
      refreshHeightOnNextTick() {
        this.$nextTick(() => {
          this.updateHeight();
        });
      },
      updateHeight() {
        const containerElement = this.$refs.container || null;
        this.height = containerElement ? containerElement.offsetHeight : 0;
      },
    },
    watch: {
      show() {
        this.refreshHeightOnNextTick();
      },
      top() {
        this.refreshHeightOnNextTick();
      },
    },
  };
</script>

<style scoped>
  .banner-fixed {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 5;
    background: rgb(var(--v-theme-surface));
  }
</style>
